// ============================================================
// Theme store - Fase 3.
//
// Manejo: 2 paletas dark (rabbit naranja default, classic verde sage).
// La app SIEMPRE esta en dark mode (no hay light). Lo unico que cambia
// es data-theme="rabbit" | "classic" en <html>, que redefine los tokens
// del primario, accent, ring y los del sidebar.
// Persistencia en localStorage para boot inmediato sin flash.
// ============================================================

export type Theme = 'rabbit' | 'classic';

interface ThemeState {
  theme: Theme;
}

const STORAGE_KEY = 'rhdash:theme';

function readStored(): ThemeState {
  if (typeof window === 'undefined') return { theme: 'rabbit' };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<{ theme: string }>;
      return {
        theme: parsed.theme === 'classic' ? 'classic' : 'rabbit',
      };
    }
  } catch {
    // ignore
  }
  return { theme: 'rabbit' };
}

function applyToDom(state: ThemeState): void {
  if (typeof document === 'undefined') return;
  const html = document.documentElement;
  html.dataset.theme = state.theme;
  // App siempre en dark - no toggle de modo.
  html.classList.add('dark');
  html.classList.remove('light');
}

const initial = readStored();
applyToDom(initial);

export const themeStore = $state<ThemeState>(initial);

function persist(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(themeStore));
  } catch {
    // ignore (modo privado)
  }
  applyToDom(themeStore);
}

export function setTheme(t: Theme): void {
  themeStore.theme = t;
  persist();
}
